module.exports = "/_next/static/images/bitcourier-transparent-03bab0a4390617ae2bb405565fe5c4ff.png";